export default __webpack_public_path__ + "static/media/info-icon.209419e2.svg";